<template>
	<div class="card">
        <div class="card-body">
            <div class="d-flex align-items-center">
                <div>
                    <h4 class="card-title">{{$t("page.content_dashboard.graficas.capacitacion_one.title")}}</h4>
                    <h5 class="card-subtitle">{{$t("page.content_dashboard.graficas.capacitacion_one.sub_title")}}</h5>
                </div>
                <div class="ml-auto">
                    <ul class="list-inline font-12 dl m-r-10">
                        <li v-if="presencial > 0" class="list-inline-item">
                            <i
                                class="fas fa-dot-circle"
                                v-bind:style="{
                                    'color': cia.color_1_grafica
                                }" ></i>
                            {{$t("page.content_dashboard.graficas.capacitacion_one.modalidad_one")}}
                        </li>
                        <li v-if="virtual > 0" class="list-inline-item">
                            <i
                                class="fas fa-dot-circle"
                                v-bind:style="{
                                    'color': cia.color_2_grafica
                                }" ></i>
                            {{$t("page.content_dashboard.graficas.capacitacion_one.modalidad_two")}}
                        </li>
                        <li v-if="streaming > 0" class="list-inline-item">
                          <i
                            class="fas fa-dot-circle"
                            v-bind:style="{
                              'color': cia.color_3_grafica
                            }"
                          ></i>
                          {{$t("page.content_dashboard.graficas.capacitacion_one.modalidad_three")}}
                        </li>
                    </ul>
                </div>
            </div>
            <div id="basic-bar" style="height:300px;"></div>
        </div>
    </div>
</template>

<script>
export default {
    data () {

      return {
        loading:'',
        result:'d-none',
        datos: [],
        presencial: 0,
        virtual: 0,
        streaming: 0,
      }
    },
    methods:{
        Consultar(){
          this.$http.get('dashboard/modalidadxmes')
          .then(respuesta=>{return respuesta.json()})
          .then(respuestaJson=>{
            this.datos = respuestaJson;
            this.Configurar_Grafica();
          })
          .catch(error=>{
          });
        },
        Configurar_Grafica(){
            var that =  this;
            var myChart = echarts.init(document.getElementById('basic-bar'));
            var legends = [];
            var presencial = [];
            var virtual = [];
            var streaming = [];
            var tiene_mes = false;
            for (var i = 1; i < 13; i++) {

                tiene_mes=false;
                for (var x = 0; x < this.datos.length; x++) {
                    if (parseInt(this.datos[x].nummes) == i) {
                        tiene_mes = true;
                    }
                }

                if (!tiene_mes) {
                    var period = this.Periodos(i);
                    this.datos.push({
                        'nummes': i,
                        'period': period,
                        'presencial': 0,
                        'virtual': 0,
                        'streaming': 0,
                    });
                }

            }
            var nuevos_datos = [];
            for (var i = 1; i < 13; i++) {
                for (var x = 0; x < this.datos.length; x++) {
                    if (parseInt(this.datos[x].nummes)==i) {
                        nuevos_datos.push(this.datos[x]);
                    }
                }
            }
            this.datos =nuevos_datos;
            for (var i = 0; i < this.datos.length; i++) {
                legends.push(this.datos[i]['period']);
                presencial.push(parseInt(this.datos[i].presencial));
                virtual.push(parseInt(this.datos[i].virtual));
                streaming.push(parseInt(this.datos[i].streaming));
            }

            this.datos.forEach(dato => {
              this.presencial += parseInt(dato.presencial);
              this.virtual += parseInt(dato.virtual);
              this.streaming += parseInt(dato.streaming);
            });
            var option = {
                // Setup grid
                grid: {
                    left: '1%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true
                },

                // Add Tooltip
                tooltip : {
                    trigger: 'axis'
                },

                legend: {
                    data:[]
                },
                toolbox: {
                    show : false,
                    feature : {
                        magicType : {show: false, type: ['line', 'bar']},
                        restore : {show: false},
                        saveAsImage : {show: false}
                    }
                },
                color: [
                    that.cia.color_1_grafica,
                    that.cia.color_2_grafica,
                    that.cia.color_3_grafica,
                ],
                calculable : false,
                xAxis : [
                    {
                        type : 'category',
                        data : [this.$t('page.dashboard_meses.ene'),this.$t('page.dashboard_meses.feb'),this.$t('page.dashboard_meses.mar'),this.$t('page.dashboard_meses.abr'),this.$t('page.dashboard_meses.may'),this.$t('page.dashboard_meses.jun'),this.$t('page.dashboard_meses.jul'),this.$t('page.dashboard_meses.ago'),this.$t('page.dashboard_meses.sep'),this.$t('page.dashboard_meses.oct'),this.$t('page.dashboard_meses.nov'),this.$t('page.dashboard_meses.dic')]
                    }
                ],
                yAxis : [
                    {
                        type : 'value'
                    }
                ],
                series : [
                    {
                        name:'Presencial',
                        type:'bar',
                        data:presencial
                    },
                    {
                        name:'Virtual',
                        type:'bar',
                        data:virtual
                    },
                    {
                        name:'Streaming',
                        type:'bar',
                        data:streaming
                    }
                ]
            };
            myChart.setOption(option);
        },
        Periodos(numero){
            var period = 'ENE';
            switch(numero){
                case 1:
                period='ENE';
                break;
                case 2:
                period='FEB';
                break;
                case 3:
                period='MAR';
                break;
                case 4:
                period='ABR';
                break;
                case 5:
                period='MAYO';
                break;
                case 6:
                period='JUN';
                break;
                case 7:
                period='JUL';
                break;
                case 8:
                period='AGO';
                break;
                case 9:
                period='SEP';
                break;
                case 10:
                period='OCT';
                break;
                case 11:
                period='NOV';
                break;
                case 12:
                period='DIC';
                break;
            }
            return period;
        }
    },
    computed:{
        cia(){
          return this.$store.getters.getCia;
        }
    },
    mounted(){
        this.Consultar();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/ModalidadxMes/ModalidadxMes.vue